// src/components/ProjectDetails.js (Corrected and more robust)

import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import "./ProjectDetails.css";

const ProjectDetails = () => {
  const { projectId } = useParams();
  const [project, setProject] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  // State for image gallery
  const [activeMainImage, setActiveMainImage] = useState("");
  const [enlargedImage, setEnlargedImage] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);

    const fetchProject = async () => {
      setIsLoading(true);
      try {
        const response = await axios.get(
          `https://apiqms.shigjeta.com/api/projects/${projectId}`
        );
        let projectData = response.data;

        // The front-end fix for parsing string data (from previous step)
        if (
          projectData.additionalImages &&
          typeof projectData.additionalImages === "string"
        ) {
          try {
            projectData.additionalImages = JSON.parse(
              projectData.additionalImages
            );
          } catch (e) {
            console.error(
              "Failed to parse 'additionalImages' string from API:",
              e
            );
            projectData.additionalImages = [];
          }
        } else if (!projectData.additionalImages) {
          projectData.additionalImages = [];
        }

        if (
          projectData.specifications &&
          typeof projectData.specifications === "string"
        ) {
          try {
            projectData.specifications = JSON.parse(projectData.specifications);
          } catch (e) {
            projectData.specifications = projectData.specifications
              .split(/\r?\n/)
              .filter((spec) => spec.trim() !== "");
          }
        } else if (!projectData.specifications) {
          projectData.specifications = [];
        }

        setProject(projectData);

        const initialMainImageUrl =
          projectData.mainImage && !projectData.mainImage.startsWith("http")
            ? `https://apiqms.shigjeta.com${projectData.mainImage}`
            : projectData.mainImage;
        setActiveMainImage(initialMainImageUrl);
      } catch (err) {
        console.error("Error fetching project details:", err);
        setError("Failed to load project details.");
      } finally {
        setIsLoading(false);
      }
    };

    if (projectId) {
      fetchProject();
    }
  }, [projectId]);

  // Handlers for image interactions
  const handleThumbnailClick = (newImageUrl) => setActiveMainImage(newImageUrl);
  const handleEnlargeImage = (imgSrc) => setEnlargedImage(imgSrc);
  const handleCloseEnlargedImage = () => setEnlargedImage(null);

  if (isLoading)
    return <div className="loading-message">Loading Project...</div>;
  if (error) return <div className="error-message">{error}</div>;
  if (!project) return <div className="info-message">Project not found.</div>;

  return (
    <>
      <div className="project-detail-page">
        <div className="project-detail-container">
          <div className="project-image-column">
            {activeMainImage && (
              <img
                src={activeMainImage}
                alt={project.name}
                className="project-main-image"
                onClick={() => handleEnlargeImage(activeMainImage)}
              />
            )}
            {project.additionalImages.length > 0 && (
              <div className="project-additional-images">
                {/* ======================================================= */}
                {/* === THIS MAPPING LOGIC IS NOW FIXED AND ROBUST === */}
                {/* ======================================================= */}
                {project.additionalImages.map((imageItem, index) => {
                  // Defensive check: skip any null or invalid items in the array
                  if (!imageItem) return null;

                  let imageUrl = "";
                  let imageAlt =
                    project.name || `Additional image ${index + 1}`;

                  // Check if the item is an object with a 'src' property
                  if (typeof imageItem === "object" && imageItem.src) {
                    imageUrl = imageItem.src;
                    imageAlt = imageItem.alt || imageAlt;
                  }
                  // Check if the item is just a string (the URL)
                  else if (typeof imageItem === "string") {
                    imageUrl = imageItem;
                  }
                  // If it's neither, we can't render it, so we skip it.
                  else {
                    return null;
                  }

                  // Construct the final, safe URL
                  const finalImageUrl = imageUrl.startsWith("http")
                    ? imageUrl
                    : `https://apiqms.shigjeta.com${imageUrl}`;

                  return (
                    <img
                      key={index}
                      src={finalImageUrl}
                      alt={imageAlt}
                      className="additional-image-item"
                      onClick={() => handleThumbnailClick(finalImageUrl)}
                    />
                  );
                })}
              </div>
            )}
          </div>
          <div className="project-info-column">
            <h1 className="project-detail-title">{project.name}</h1>
            <div
              className="project-detail-description"
              dangerouslySetInnerHTML={{ __html: project.description }}
            />
            {project.specifications.length > 0 && (
              <div className="project-specifications">
                <h3>Specifications</h3>
                <ul>
                  {project.specifications.map((spec, index) => (
                    <li key={index}>{spec}</li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>
      {enlargedImage && (
        <div
          className="enlarged-image-container"
          onClick={handleCloseEnlargedImage}
        >
          <div className="enlarged-image-content">
            <img
              src={enlargedImage}
              alt="Enlarged View"
              className="enlarged-image"
            />
            <button
              className="enlarged-image-close-btn"
              onClick={handleCloseEnlargedImage}
            >
              &times;
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default ProjectDetails;
